<!-- Main Row Container -->
<div class="row">
  <div class="d-flex mb-3 mt-4">
    <div class="d-flex">
      <div class="fnf-segmented ml-3" role="tablist">
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="selectedStatusLabel === 'all'"
          (click)="filterOrders('all')"
        >
          All
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="selectedStatusLabel === 'active'"
          (click)="filterOrders('active')"
        >
          Active
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="selectedStatusLabel === 'completed'"
          (click)="filterOrders('completed')"
        >
          Completed
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="selectedStatusLabel === 'archived'"
          (click)="filterOrders('archived')"
        >
          Archived
        </button>
      </div>
      <div class="d-flex">
        <label class="order-type-label pl-3 pt-3">Order Type : </label>
        <div class="dropdown ml-3 pt-2">
          <button
            class="btn dropdown-toggle border-bottom rounded-1"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ displayOrderType }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            @for (type of orderTypes; track type; let i = $index) {
              <li (click)="onOrdertypeChange(type)">
                <a class="dropdown-item">{{ type.label }}</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
    <div class="ms-auto mt-2">
      <div class="stat-select mx-3">
        <div class="dropdown">
          <button
            class="btn dropdown-toggle bg-white rounded-5"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ displayTimeRange }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            @for (timeRange of timeRanges; track timeRange; let i = $index) {
              <li (click)="onTimeRangeChange(timeRange)">
                <a class="dropdown-item">{{ timeRange.label }}</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

@if (displayOrders?.length > 0) {
  <div class="justify-content-start align-baseline py-2 my-2 pl-4 pr-4 d-none">
    <div class="sorting-pagination">
      <div class="pagination">
        <div class="results-per-page">
          <div class="per-page">Per page:</div>
          <div class="dropdown">
            <button
              class="btn dropdown-toggle bg-white rounded-5"
              type="button"
              id="dropdownMenuButton2"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ itemsPerPage }} items
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
              @for (option of [10, 20, 50, 100]; track option; let i = $index) {
                <li (click)="changeItemsPerPage(option)">
                  <a class="dropdown-item">{{ option }}</a>
                </li>
              }
            </ul>
          </div>
        </div>
        <!-- <div class="bullet"></div> -->
        <div class="page-2-of-6">
          <span>
            <span class="page-2-of-6-span">Page</span>
            <span class="page-2-of-6-span2 pl-2 pr-2">{{ currentPage }}</span>
            <!-- <span class="page-2-of-6-span3">of</span> -->
            <!-- <span class="page-2-of-6-span4 pl-2 pr-2">{{totalPages}}</span> -->
          </span>
        </div>
        <div class="navigation">
          <button
            class="btn nav-button"
            [disabled]="currentPage === 1"
            (click)="changePage(currentPage - 1)"
          >
            <i class="bx bx-chevron-left"></i>
          </button>
          <button
            class="btn nav-button"
            [disabled]="disableNextBtn"
            (click)="changePage(currentPage + 1)"
          >
            <i class="bx bx-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="right" hidden>
        <div class="view-as">
          <div class="view-as2">View as:</div>
          <div class="button">
            <div class="large-grid">Large Grid</div>
            <div class="icon">
              <div class="arrow-down">
                <!-- <img class="arrow-down-012" src="arrow-down-011.svg" /> -->
              </div>
            </div>
            <!-- <img class="underline2" src="underline1.svg" /> -->
          </div>
        </div>
        <div class="sort-by">
          <div class="sort-by2">Sort by:</div>
          <div class="button">
            <div class="price-high-to-low">Price - high to low</div>
            <div class="icon">
              <div class="arrow-down">
                <!-- <img class="arrow-down-013" src="arrow-down-012.svg" /> -->
              </div>
            </div>
            <!-- <img class="underline3" src="underline2.svg" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- Conditional Rendering for Table View -->
<div class="row mt-4 pl-3 mb-5">
  @if (displayLoading) {
    <div class="d-flex flex-wrap gap-4 align-content-center justify-content-start">
      @for (placeholder of skeletonPlaceholders; track $index) {
        <div class="skeleton-card">
          <div class="skeleton-header-row">
            <div class="skeleton-shimmer skeleton-badge"></div>
            <div class="skeleton-header-lines">
              <div class="skeleton-shimmer skeleton-line w-60"></div>
              <div class="skeleton-shimmer skeleton-line w-40"></div>
            </div>
            <div class="skeleton-shimmer skeleton-status-pill"></div>
          </div>
          @for (row of [1, 2]; track row) {
            <div class="skeleton-item-row">
              <div class="skeleton-shimmer skeleton-thumb"></div>
              <div class="skeleton-item-lines">
                <div class="skeleton-shimmer skeleton-line w-80"></div>
                <div class="skeleton-shimmer skeleton-line w-40"></div>
              </div>
              <div class="skeleton-shimmer skeleton-line skeleton-line-price"></div>
            </div>
          }
          <div class="skeleton-divider"></div>
          @for (row of [1, 2, 3]; track row) {
            <div class="skeleton-total-row">
              <div class="skeleton-shimmer skeleton-line w-30"></div>
              <div class="skeleton-shimmer skeleton-line w-25"></div>
            </div>
          }
        </div>
      }
    </div>
  } @else if (displayOrders?.length > 0) {
    <div class="d-flex flex-wrap gap-4 align-content-center justify-content-start">
      @for (order of displayOrders; track order; let i = $index) {
        <div class="card-order-container" (click)="getOrderById(order.order_id)">
          <div class="d-flex flex-column w-100">
            <div class="d-flex justify-content-start pb-2">
              <div class="">
                <div class="table1">
                  @if (order?.order_type == 'togo' || order?.order_type == 'togo_dine_in') {
                    ToGo
                  } @else if (order?.online_platform_type && order?.order_type == 'online') {
                    {{
                      order?.online_platform_type == 'forknfind'
                        ? 'F&F'
                        : order?.online_platform_type
                    }}
                  } @else if (order?.tables?.length > 0) {
                    {{ order?.tables[0]?.table_name }}
                  } @else {
                    N/A
                  }
                </div>
              </div>
              <div class="flex-fill name-order-no pl-2 pr-2">
                <div class="order--customer-name" matTooltip="{{ order.customers[0].first_name }}">
                  {{ order.customers[0].first_name }}
                </div>
                <div class="order-number">Order {{ order.order_number }}</div>
              </div>
              <div class="d-flex flex-column align-items-end flex-grow-1">
                @if (
                  order.status == 'ready_to_order' ||
                  order.status == 'in_progress' ||
                  order.status == 'ready_for_payment' ||
                  order.status == 'payment_option_selected' ||
                  order.status == 'payment_completed'
                ) {
                  <div class="badge-ready-to-order">
                    <div class="icon">
                      <div class="ready-to-order">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.16677 5.33334H13.9641C14.3806 5.33334 14.5889 5.33334 14.7414 5.40057C15.4158 5.69794 15.1143 6.44718 15.0008 6.98561C14.9804 7.08234 14.9141 7.16468 14.8212 7.20881C14.4356 7.39174 14.1656 7.73874 14.0947 8.14228L13.6996 10.3919C13.5258 11.3817 13.4664 12.7962 12.599 13.4935C11.9626 14 11.0457 14 9.21177 14H7.78844C5.95452 14 5.03757 14 4.40117 13.4935C3.53378 12.7961 3.47436 11.3817 3.30054 10.3919L2.90548 8.14228C2.83462 7.73874 2.56459 7.39174 2.17904 7.20881C2.08608 7.16468 2.01978 7.08234 1.9994 6.98561C1.88593 6.44718 1.58437 5.69794 2.25885 5.40057C2.41133 5.33334 2.61958 5.33334 3.03608 5.33334H5.5001"
                            stroke="#F7933B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M9.83348 8H7.16681"
                            stroke="#F7933B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.83344 7.33333L7.16677 2M10.5001 2L12.1668 5.33333"
                            stroke="#F7933B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div class="order-status-name">{{ order.displayStatus }}</div>
                  </div>
                  <div class="time-ellapsed mt-1 d-none">
                    <div class="sub-badge-ready-to-order">
                      <div class="time-count">1h 12m 42s</div>
                    </div>
                  </div>
                } @else if (order.status == 'order_placed') {
                  <div class="badge-order-placed">
                    <div class="icon">
                      <div class="order-placed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M7.66683 5.33334H13.4642C13.8807 5.33334 14.089 5.33334 14.2414 5.40057C14.9159 5.69794 14.6144 6.44718 14.5009 6.98561C14.4805 7.08234 14.4142 7.16468 14.3212 7.20881C13.9632 7.37868 13.7591 7.66094 13.6445 8.00001M5.00016 5.33334H2.53614C2.11964 5.33334 1.91139 5.33334 1.75891 5.40057C1.08443 5.69794 1.38599 6.44718 1.49946 6.98561C1.51984 7.08234 1.58614 7.16468 1.6791 7.20881C2.06465 7.39174 2.33468 7.73874 2.40554 8.14228L2.8006 10.3919C2.97442 11.3817 3.03384 12.7961 3.90123 13.4935C4.53763 14 5.45458 14 7.2885 14H7.66683"
                            stroke="#399351"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M9.3335 12.6667C9.3335 12.6667 10.0002 12.6667 10.6668 14C10.6668 14 12.7845 10.6667 14.6668 10"
                            stroke="#399351"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.3335 7.33333L6.66683 2M10.0002 2L11.6668 5.33333"
                            stroke="#399351"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div class="order-status-name">{{ order.displayStatus }}</div>
                  </div>
                  <div class="time-ellapsed mt-1">
                    <div class="sub-badge-order-placed d-none">
                      <div class="time-count">1h 12m 42s</div>
                    </div>
                  </div>
                } @else if (order.status == 'completed') {
                  <div class="badge-order-completed">
                    <div class="icon">
                      <div class="order-completed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M2.50012 8.88887C2.50012 8.88887 3.50012 9.33333 4.83346 11.3333C4.83346 11.3333 5.02336 11.0128 5.38101 10.5017M11.8335 4C10.3058 4.76385 8.70806 6.36787 7.42539 7.88153"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5.83344 8.88887C5.83344 8.88887 6.83344 9.33333 8.16677 11.3333C8.16677 11.3333 11.8334 5.66667 15.1668 4"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div class="order-completed-text">{{ order.displayStatus }}</div>
                  </div>
                  <div class="time-ellapsed mt-1">
                    <div class="sub-badge-order-completed d-none">
                      <div class="order-completed-time">1h 12m 42s</div>
                    </div>
                  </div>
                } @else if (order.status == 'cancelled') {
                  <div class="badge-order-completed bg-danger bg-gradient">
                    <div class="icon">
                      <div class="order-completed">
                        <span class="bx bx-x-circle text-white pt-1"></span>
                      </div>
                    </div>
                    <div class="order-completed-text">{{ order.displayStatus }}</div>
                  </div>
                  <div class="time-ellapsed mt-1">
                    <div class="sub-badge-order-completed d-none">
                      <div class="order-completed-time">1h 12m 42s</div>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="d-flex justify-content-ceneter mt-1 mb-1 custome-line">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="278" height="2" viewBox="0 0 278 2" fill="none">
                            <path d="M1.25 1H277.5" stroke="#D7DAE0" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 4"/>
                        </svg> -->
            </div>

            <div class="d-flex justify-content-between pt-2 pb-2">
              <div class="waiter">
                @if (order.order_type == 'togo' || order.order_type == 'online') {
                  <div class="order-time">{{ displayCreateddate(order.created_at) }}</div>
                } @else {
                  @if (order.served_by?.img_path?.trim()) {
                    <img
                      class="avatar"
                      [src]="order.served_by.img_path"
                      (error)="onServedByImageError($event)"
                    />
                  } @else if (order.served_by?.first_name) {
                    <span class="avatar-name pl-2">{{
                      getFirstLetterOfString(order.served_by?.first_name)
                    }}</span>
                  } @else {
                    <img class="avatar" src="assets/default/profile.png" />
                  }
                  <div class="waiter-details">
                    <div class="order-time">{{ displayCreateddate(order.created_at) }}</div>
                    <div class="d-flex gap-1">
                      <span class="served-by">Served by: </span
                      ><span class="me">{{
                        order.served_by?.first_name ? order.served_by?.first_name : 'N/A'
                      }}</span>
                    </div>
                  </div>
                }
              </div>
              <div class="profiles">
                <div class="profiles2">
                  @for (
                    customer of order.customers?.slice(0, maxCardCustomers);
                    track customer;
                    let c = $index
                  ) {
                    <div [matTooltip]="customer.first_name">
                      @if (hasCustomerImage(customer)) {
                        <img
                          [class]="c == 0 ? 'avatar2' : 'avatar3'"
                          [src]="customer.img_path.trim()"
                          [alt]="customer.first_name"
                          loading="lazy"
                          (error)="onCustomerImageError(customer)"
                        />
                      } @else {
                        <span
                          [style.background-color]="getRgbaColor(customer.configs?.color_code, 0.2)"
                          [style.color]="customer.configs?.color_code"
                          [class]="c == 0 ? 'avatar2' : 'avatar3'"
                        >
                          {{ getFirstLetterOfString(customer.first_name) }}
                        </span>
                      }
                    </div>
                  }
                  @if (order.customers?.length > maxCardCustomers) {
                    <div [matTooltip]="hiddenCustomerNames(order)">
                      <span class="avatar3 avatar-more"
                        >+{{ order.customers.length - maxCardCustomers }}</span
                      >
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-ceneter mt-1 mb-1 custome-line">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="278" height="2" viewBox="0 0 278 2" fill="none">
                            <path d="M1.25 1H277.5" stroke="#D7DAE0" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 4"/>
                        </svg> -->
            </div>
            @if (order.menu_items.length == 0) {
              <div class="d-flex justify-content-center pt-2 pb-2 m-auto" style="min-height: 135px">
                <div class="table2">
                  <div class="empty-state m-auto">
                    <img class="image" src="./../../../../assets/empty-menu.png" />
                    <div class="title-description">
                      <div class="the-cart-is-empty">The cart is empty!</div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="d-flex justify-content-between pt-2 pb-2" style="min-height: 135px">
                <div class="table2 w-100">
                  <div class="header2">
                    <div class="tables-cell">
                      <div class="items">Items</div>
                    </div>
                    <div class="tables-cell2">
                      <div class="qty">Qty</div>
                    </div>
                    <div class="tables-cell3">
                      <div class="price">Price</div>
                    </div>
                  </div>
                  <div class="w-100">
                    @for (item of order.menu_items; track item; let mi = $index) {
                      @if (mi <= 2) {
                        <div class="header2 pb-2">
                          <div class="tables-cell">
                            <div
                              class="items font-11 text-dark d-flex"
                              matTooltip="{{ item.name }}"
                            >
                              {{ truncateString(item.name, 32) }}
                              @if (item.veg) {
                                <div class="icon2 ml-1">
                                  <div class="veg">
                                    <div class="bullet"></div>
                                    <div class="bullet2"></div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                          <div class="tables-cell2">
                            <div class="qty font-11 text-dark">{{ item.quantity }}</div>
                          </div>
                          <div class="tables-cell3">
                            <div class="price font-11 text-dark">
                              <span class="total-currency">$</span
                              >{{ item.total | number: '1.2-2' }}
                            </div>
                          </div>
                        </div>
                      } @else if (mi > 2 && mi < 4) {
                        <div class="more-details m-auto w-25">
                          <div class="_8-more">+{{ order.menu_items.length - 3 }} more</div>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            }

            <div class="d-flex justify-content-ceneter mt-1 mb-1 custome-line">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="278" height="2" viewBox="0 0 278 2" fill="none">
                            <path d="M1.25 1H277.5" stroke="#D7DAE0" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 4"/>
                        </svg> -->
            </div>
            <div class="d-flex justify-content-between pt-2 align-items-center total-price1">
              <div class="">Total</div>
              <div class="">
                <span class="total-currency">$</span>{{ order.total | number: '1.2-2' }}
              </div>
            </div>
            <div class="d-flex justify-content-between pt-2 align-items-center total-price1">
              <div class="">Refund</div>
              <div [ngClass]="{ 'refund-value': order.total_refund > 0 }">
                <span class="total-currency">$</span>{{ order.total_refund | number: '1.2-2' }}
              </div>
            </div>
            <div class="d-flex justify-content-between pt-2 align-items-center total-price1">
              <div class="">NET TOTAL</div>
              <div class="">
                <span class="total-currency">$</span
                >{{ order.total_after_refund | number: '1.2-2' }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Scroll Sentinel for Infinite Scroll - Triggers load more when scrolled into view -->
    <div #scrollSentinel class="scroll-sentinel bg-danger"></div>

    <!-- Loading More Indicator -->
    @if (loadingMore) {
      <div class="d-flex flex-column align-items-center justify-content-center py-4">
        <img
          class="common-loading"
          src="assets/menu_loading.gif"
          alt="Loading more orders"
          style="width: 50px; height: 50px"
        />
        <p class="common-loading-text mt-2">Loading more orders...</p>
      </div>
    }
  } @else {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/no-orders-yet.svg" alt="No Devices" class="common-empty-img mb-3" />
      <p class="common-empty-header">{{ getEmptyStateMessage() }}</p>
      <p class="common-empty-sub-text">{{ getEmptyStateDescription() }}</p>
    </div>
  }
</div>
